export default {"src":"/_next/static/media/alert-icon-off.911d4aaf.svg","height":24,"width":24};